// The small marks Free resources and Free webinars draw (FreeResources.dc.html, FreeWebinars.dc.html).
// Line icons take the text's colour; .icon-line is the shell's (shell.css).

export function BackArrow({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  )
}

// Opens somewhere else, in a new tab
export function OutArrow({ size = 15 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  )
}

export function DownloadIcon() {
  return (
    <svg className="icon-line" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
    </svg>
  )
}

export function PlayIcon({ size = 14 }) {
  return (
    <svg className="icon-fill" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  )
}

export function TickIcon() {
  return (
    <svg className="icon-line fr-tick" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2.5 }}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

export function InfoIcon() {
  return (
    <svg className="icon-line fr-info-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 1.75 }}>
      <circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" />
    </svg>
  )
}

// The Next Deal Scorecard's mark: 5 bars, the middle one tall, on the Accelerator's green
export function BarsMark() {
  return (
    <svg className="fr-bars" width="46" height="46" viewBox="0 0 46 46" aria-hidden="true">
      <rect className="fr-bars-ground" x="0" y="0" width="46" height="46" rx="11" />
      <rect className="fr-bars-bar" x="9" y="24" width="4" height="12" rx="1" />
      <rect className="fr-bars-bar" x="15.5" y="24" width="4" height="12" rx="1" />
      <rect className="fr-bars-bar" x="22" y="10" width="4" height="26" rx="1" />
      <rect className="fr-bars-bar" x="28.5" y="24" width="4" height="12" rx="1" />
      <rect className="fr-bars-bar" x="35" y="24" width="4" height="12" rx="1" />
    </svg>
  )
}
